import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class DatosComprador extends Component {
    render() {
        const { isSeller, isSellerAdmin, isAdminMod } = this.props.userType;
        const { orden } = this.props.orden;
        const cliente = orden?.cliente || this.props.orden.cliente || {};

        const showContactInfo =
            isAdminMod || isSeller || isSellerAdmin;

        return (
            <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
                <div className="row">

                    <div className="form-group col-lg-6">
                        <label htmlFor="documentoDatosComprador">{cliente?.tipoDocumento || "DNI"}</label>
                        <input
                            id="documentoDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.documento}
                            placeholder=""
                            name="documento"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="nombreDatosComprador">Nombre comprador</label>
                        <input
                            id="nombreDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.nombre + ' ' + cliente.apellido}
                            placeholder=""
                            name="nombre"
                        />
                    </div>

                    <div className="form-group col-lg-3">
                        <label htmlFor="calleDatosComprador">Calle</label>
                        <input
                            id="calleDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.calle}
                            placeholder=""
                            name="calle"
                        />
                    </div>

                    <div className="form-group col-lg-3">
                        <label htmlFor="numeroDatosComprador">Número</label>
                        <input
                            id="numeroDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.numero}
                            placeholder=""
                            name="numero"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="pisoDatosComprador">Piso</label>
                        <input
                            id="pisoDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.piso}
                            placeholder=""
                            name="piso"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="departamentoDatosComprador">Departamento</label>
                        <input
                            id="departamenteDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.departamento}
                            placeholder=""
                            name="departamento"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="codigoPostalDatosComprador">Código postal</label>
                        <input
                            id="codigoPostalDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.codigoPostal}
                            placeholder=""
                            name="codigoPostal"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="localidadDatosComprador">Localidad</label>
                        <input
                            id="localidadDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.localidad}
                            placeholder=""
                            name="localidad"
                        />
                    </div>

                    <div className="form-group col-lg-6">
                        <label htmlFor="provinciaDatosComprador">Provincia</label>
                        <input
                            id="provinciaDatosComprador"
                            type="text"
                            className="form-control"
                            value={cliente.provincia}
                            placeholder=""
                            name="provincia"
                        />
                    </div>

                    {showContactInfo &&
                        <>
                            <div className="form-group col-lg-6">
                                <label htmlFor="emailDatosComprador">Email</label>
                            <input
                                    id="emailDatosComprador"
                                    type="text"
                                    className="form-control"
                                    value={cliente.email}
                                    placeholder=""
                                />
                            </div>

                            <div className="form-group col-lg-6">
                                <label htmlFor="telefonoDatosComprador">Teléfono</label>
                            <input
                                    id="telefonoDatosComprador"
                                    type="text"
                                    className="form-control"
                                    value={cliente.telefono}
                                    placeholder=""
                                />
                            </div>
                        </>
                    }

                </div>
            </div>
        );
    }
}
DatosComprador.propTypes = {
    userType: PropTypes.shape({
        isSellerAdmin: PropTypes.bool,
        isSeller: PropTypes.bool,
        isAdminMod: PropTypes.bool,
    }),
    orden: PropTypes.shape({
        orden: PropTypes.shape({
            cliente: PropTypes.object,
            seller: PropTypes.shape({
                mostrarInfoContacto: PropTypes.bool,
                envioPropio: PropTypes.bool,
            }),
        }),
        cliente: PropTypes.object,
    })
}

const mapStateToProps = state => ({
    userType: state.general.userType,
    orden: state.ordenes
});

export default connect(mapStateToProps)(DatosComprador);